












































import { computed, defineComponent } from '@nuxtjs/composition-api'
import { PRODUCT_TYPES } from '~/common/utils/product/constants'
import { MappedProduct } from '~/types/product/productTypes'

export default defineComponent({
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
  },
  setup(props) {
    const firstSku = computed(() => Object.values(props.product.skuData)[0])
    const skuData = computed(() => Object.values(props.product.skuData))
    const showUnitSize = computed(() =>
      [
        PRODUCT_TYPES.GROWTH_FACTORS_AND_CYTOKINES,
        PRODUCT_TYPES.CHEMICAL_MODULATORS,
        PRODUCT_TYPES.ELISA_ANTIBODY_PAIR,
        PRODUCT_TYPES.ANTIBODY_SAMPLER_KIT,
        PRODUCT_TYPES.OLIGO_ANTIBODY_PAIR,
        PRODUCT_TYPES.FAST_SCAN_ELISA_KIT,
        PRODUCT_TYPES.ELISA_KIT,
        PRODUCT_TYPES.PROTEIN_CONTROL,
        PRODUCT_TYPES.CELLULAR_DYES,
        PRODUCT_TYPES.CELL_EXTRACTS,
        PRODUCT_TYPES.PTM_SCAN,
        PRODUCT_TYPES.DETECTION_SYSTEM,
      ].includes(props.product.productType)
    )

    const showTests = computed(() =>
      [
        PRODUCT_TYPES.ELISA_ANTIBODY_PAIR,
        PRODUCT_TYPES.ANTIBODY_SAMPLER_KIT,
        PRODUCT_TYPES.OLIGO_ANTIBODY_PAIR,
        PRODUCT_TYPES.FAST_SCAN_ELISA_KIT,
        PRODUCT_TYPES.ELISA_KIT,
        PRODUCT_TYPES.CELL_EXTRACT_KIT,
        PRODUCT_TYPES.PTM_SCAN,
        PRODUCT_TYPES.PROTEIN_CONTROL_KIT,
      ].includes(props.product.productType)
    )

    return {
      firstSku,
      skuData,
      showUnitSize,
      showTests,
      PRODUCT_TYPES,
    }
  },
})
